import Image1 from '../../assets/project1.png'
import Image2 from '../../assets/project2.png'
import Image3 from '../../assets/project3.png'
import Image4 from '../../assets/reliance.png'
import ImageKoret from '../../assets/project_koret.png'
import Image6 from '../../assets/project6.png'
import ImageBespoke from '../../assets/bespoke-labs.png'

const data = [
    {
        id: 8,
        category: 'AI/ML',
        image: ImageBespoke,
        title: "Bespoke Labs",
        desc: "AI research company building infrastructure to ship reliable agents. As Senior Platform Engineer, I design and maintain distributed Kubernetes infrastructure powering LLM benchmarking, agent evaluation pipelines, and research workflows — supporting published work including OpenThoughts (used by 200+ model builders), TerminalBench, and GEPA, all accepted to ICLR 2026.",
        demo: 'https://www.bespokelabs.ai/',
        github: 'https://github.com/omonuj'
    },
    {
        id: 1,
        category: 'frontend and backend',
        image: Image1,
        title: "Seamoss Nigeria",
        desc: "Full-stack eCommerce platform for a Nigerian health and wellness brand — featuring product listings, cart management, and payment integration built for performance and mobile responsiveness.",
        demo: 'http://seamossnigeria.com',
        github: 'https://github.com/omonuj'
    },
    {
        id: 2,
        category: 'backend',
        image: Image2,
        title: "Karabo",
        desc: "Nigerian fintech platform offering a smart digital wallet — engineered for reliable electronic payments and collections at scale for individuals and businesses, with secure transaction processing.",
        demo: 'https://karrabo.com/',
        github: 'https://github.com/omonuj'
    },
    {
        id: 3,
        category: 'frontend and backend',
        image: Image3,
        title: "Partna",
        desc: "Full-stack real estate investment platform democratising fractional property ownership in Nigeria — built with a secure backend for investor onboarding, asset management, and transaction tracking.",
        demo: 'https://mypartna.ng',
        github: 'https://github.com/omonuj'
    },
    {
        id: 4,
        category: 'backend',
        image: Image4,
        title: "Reliance Health",
        desc: "Healthcare platform powering telemedicine, EHR, and patient management for 50k+ active patients across Africa — built with HIPAA-compliant data handling, payment gateway integrations, and 99.9% uptime.",
        demo: 'https://getreliancehealth.com/',
        github: 'https://github.com/omonuj'
    },
    {
        id: 5,
        category: 'backend',
        image: ImageKoret,
        title: "Koret Tags",
        desc: "Contactless NFC card and digital business card platform for entrepreneurs and businesses — enabling instant contact sharing, analytics, and dynamic profile management via mobile-first design.",
        demo: 'https://korettags.app/',
        github: 'https://github.com/omonuj'
    },
    {
        id: 6,
        category: 'frontend and backend',
        image: Image6,
        title: "Litz Property",
        desc: "Property management platform for Property Kraft Africa — simplifying rent collection and tenancy management for landlords and tenants with a clean, real-time dashboard and automated billing.",
        demo: 'https://lizt-frontend.vercel.app/',
        github: 'https://github.com/omonuj'
    },
]

export default data
